import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { Grid, Box, Modal, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";

import { makeStyles } from '@material-ui/core/styles';
import { getFormatedDate, fancyTimeFormat } from "../../Js/TimeAndDate";
import { currentAssetSliceActions } from "../../Store/Slices/CurrentAssetSlice";
import { commonSliceActions } from "../../Store/Slices/CommonSlice";

const AssetViewModal = (props) => {
    // Hooks
    const styles = useStyles();
    const navigation = useNavigate();
    const dispatch = useDispatch();

    //Redux state
    const { paramsdata } = useSelector((state) => state.common);

    // State
    const [assetType, setAssetType] = useState(null);

    useEffect(() => {        
        if (props.questionAttempts && props.questionAttempts.length > 0) {
            setAssetType(assetTypeFullForm(props.questionAttempts[0]['outcome']['assetType']['value']));
        }
    }, [props.questionAttempts]);

    const redirect = (attempt) => {
        // console.log("attempt=====>",attempt);
        dispatch(commonSliceActions.setParamsData({ ...paramsdata, "selectedClass": props.selectedClass }));
        dispatch(currentAssetSliceActions.setAttempedAnsLog(attempt));
        navigation(`/Report/LearnerContent/${attempt.context.assetId}`);
    }

    const assetTypeFullForm = (alias) => {
        let fullName;
        switch (alias) {
            case 'MC':
                fullName = 'Multiple Choice';
                break;
            case 'TF':
                fullName = 'True and False';
                break;
            case 'FIB':
                fullName = 'Fill in the Blanks';
                break;
            case 'JW':
                fullName = 'Jumble Words';
                break;
            case 'OO':
                fullName = 'Select Word';
                break;
            case 'COMP':
                fullName = 'Comprehenstion';
                break;
            case 'DIC':
                fullName = 'Dictation';
                break;
            case 'SB':
                fullName = 'Syllable Breakup';
                break;
            case 'REC':
                fullName = 'Recording';
                break;
            case 'MATCH':
                fullName = 'Match the following';
                break;
            case 'TFS':
                fullName = 'True and False Select';
                break;
            case 'IE':
                fullName = 'Insert Element';
                break;
            case 'RTS':
                fullName = 'Rearrange the Vertical';
                break;
            case 'NB':
                fullName = 'Notebox';
                break;
            case 'CI':
                fullName = 'Context Info';
                break;
            case 'SF':
                fullName = 'Sentence Formation';
                break;
            case 'OP':
                fullName = 'Object Pair';
                break;
            case 'WORD':
                fullName = 'Vocabulary';
                break;
            case 'RA':
                fullName = 'Read Along';
                break;
            case 'SFA':
                fullName = 'Sentence Formation Audio';
                break;
            case 'SFI':
                fullName = 'Sentence Formation Image';
                break;
            case 'WS':
                fullName = 'Word Spell';
                break;
            case 'BINGO':
                fullName = 'Boggle';
                break;
            case 'THESAURUS':
                fullName = 'Thesaurus';
                break;
            case 'CB':
                fullName = 'Conversation Builder';
                break;
            case 'WORDGROUP':
                fullName = 'Word Group';
                break;
            case 'BOOK':
                fullName = 'Book';
                break;
        }
        return fullName;
    };
    return (
        <Modal
            open={props.show}
            onClose={() => {
                if (!props.persistent) {
                    props.toggleModal(false);
                }
            }}
            sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', mx: 40}}
        >
            <Grid container
                sx={{ backgroundColor: '#F5F7FF', borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>
                <Grid
                    xs={12}
                    sx={{ flexDirection: 'row', justifyContent: 'flex-start'}}>
                    <Grid item>
                        <Box
                            className={styles.scrollBarHeight}
                            sx={{overflow: 'auto',borderRadius: 2}}
                        >
                            <TableContainer>
                                {props.questionJsonData &&
                                    <Box align="left" sx={{ color: '#FFFFFF',fontWeight: '600', padding: '10px', backgroundColor:'#DB8829', }}>
                                        <Typography sx={{ fontSize: '1.2rem', fontWeight: '600'}}>{props.questionJsonData.studentname} - {props.questionJsonData.question}</Typography>
                                        <Typography sx={{ fontSize: '0.8rem', fontWeight: '500'}}>{assetType}</Typography>
                                    </Box>
                                }
                                <Table sx={{ minWidth: 400 }} >
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center" sx={{ color: '#DB8829', fontSize: '0.9rem', fontWeight: '600', padding: '1px' }}>
                                                Trial
                                            </TableCell>
                                            <TableCell align="center" sx={{ color: '#DB8829', fontSize: '0.9rem', fontWeight: '600', padding: '1px' }}>
                                                Date
                                            </TableCell>
                                            <TableCell align="center" sx={{ color: '#DB8829', fontSize: '0.9rem', fontWeight: '600', padding: '1px' }}>
                                                Duration (MM:SS)
                                            </TableCell>
                                            <TableCell align="center" sx={{ color: '#DB8829', fontSize: '0.9rem', fontWeight: '600', padding: '1px' }}>
                                                Score
                                            </TableCell>
                                            <TableCell align="center" sx={{ color: '#DB8829', fontSize: '0.9rem', fontWeight: '600', padding: '1px' }}>
                                                Attempts
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {(props.questionAttempts && props.questionAttempts.length > 0) &&
                                            <>
                                                {props.questionAttempts.map((attempt, attemptInd) => {
                                                    return (
                                                        <TableRow key={attemptInd} sx={{ py: 0 }} onClick={() => { redirect(attempt) }}>
                                                            <TableCell align="center" sx={{ color: '#DB8829', fontSize: '0.8rem', padding: '10px' }}>
                                                                {props.questionAttempts.length - attemptInd}
                                                            </TableCell>
                                                            <TableCell align="center" sx={{ color: '#DB8829', fontSize: '0.8rem', padding: '10px' }}>
                                                                {getFormatedDate(attempt.createdAt)}
                                                            </TableCell>
                                                            <TableCell align="center" sx={{ color: '#DB8829', fontSize: '0.8rem',  padding: '10px' }}>
                                                                {fancyTimeFormat(attempt.outcome.duration)}
                                                            </TableCell>
                                                            <TableCell align="center" sx={{ color: '#DB8829', fontSize: '0.8rem', padding: '10px' }}>
                                                                {Number(attempt.outcome.genericScore).toFixed(2)}
                                                            </TableCell>
                                                            <TableCell align="center" sx={{ color: '#DB8829', fontSize: '0.8rem',  padding: '10px' }}>
                                                                {attempt.outcome.assetType.value == 'SB' ?
                                                                    <b>-</b>
                                                                    : (attempt.outcome.userAnswer) ?
                                                                        <b>{attempt.outcome.attempts}</b>
                                                                        :
                                                                        <b>1</b>
                                                                }
                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                                })
                                                }
                                            </>
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
        </Modal>
    );
};
const useStyles = makeStyles({
    scrollBarHeight: {
        "&::-webkit-scrollbar": {
            width: '0.0em'
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "#ffe600ff",
            '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
            borderRadius: 5
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#5f5600ff",
            borderRadius: 5
        }
    },
});
export default AssetViewModal;